import { Box, styled, Typography } from '@mui/material';
import type { Column } from 'react-table';
import { IconAccessTime } from 'assets/img';
import { ContextMenuButton } from 'redesign';
import { PaymentsCellProp, PaymentsColumnDefinition } from './payments.types';

export const getPaymentColumnDefinition: () => Column<PaymentsColumnDefinition>[] = () => {
  const workerName: Column<PaymentsColumnDefinition> = {
    Header: () => <Header>Naam Flexwerker</Header>,
    accessor: 'workerName',
    Cell: WorkerCell,
  };

  const paymentId: Column<PaymentsColumnDefinition> = {
    Header: () => <Header>Payment ID</Header>,
    accessor: 'paymentId',
    Cell: PaymentIdCell,
  };

  const creationDate: Column<PaymentsColumnDefinition> = {
    Header: () => <Header>Aanmaakdatum</Header>,
    accessor: 'creationDate',
    width: '150px',
    Cell: DateCell,
  };

  const invoice: Column<PaymentsColumnDefinition> = {
    Header: () => <Header>Factuur</Header>,
    accessor: 'invoice',
    width: '150px',
    Cell: InvoiceCell,
  };

  const status: Column<PaymentsColumnDefinition> = {
    Header: () => <Header>Betalingsstatus</Header>,
    accessor: 'status',
    width: '150px',
    Cell: PaymentStatusCell,
  };

  const dueDate: Column<PaymentsColumnDefinition> = {
    Header: () => <Header>Betaaldatum</Header>,
    accessor: 'dueDate',
    width: '150px',
    Cell: DateCell,
  };

  const actions: Column<PaymentsColumnDefinition> = {
    Header: () => <Header>Acties</Header>,
    accessor: 'actions',
    width: '150px',
    Cell: ActionCell,
  };

  return [workerName, paymentId, creationDate, invoice, status, dueDate, actions];
};

const Header = ({ children }: React.PropsWithChildren<unknown>) => (
  <Typography variant="body2" style={{ fontWeight: 'bold' }}>
    {children}
  </Typography>
);

const WorkerCell = (cell: PaymentsCellProp<'workerName'>) => {
  return (
    <Typography variant="body1" noWrap>
      {cell.value}
    </Typography>
  );
};

const PaymentIdCell = (cell: PaymentsCellProp<'paymentId'>) => {
  return (
    <Typography variant="body1" noWrap>
      {cell.value}
    </Typography>
  );
};

const DateCell = (cell: PaymentsCellProp<'creationDate' | 'dueDate'>) => {
  {
    return (
      <BoxInfo>
        <Typography variant="body1" color="secondary">
          {cell.value.toFormat('dd MMM yyyy')}
        </Typography>
        <BoxTime>
          <IconAccessTime />
          <Typography variant="body1">{cell.value.toFormat('HH:mm')}</Typography>
        </BoxTime>
      </BoxInfo>
    );
  }
};
const InvoiceCell = (cell: PaymentsCellProp<'invoice'>) => {
  return (
    <Box>
      {cell.value ? (
        <a href={cell.value.invoiceUrl} download>
          <Typography>{cell.value.invoiceReference}</Typography>
        </a>
      ) : null}
    </Box>
  );
};
const PaymentStatusCell = (cell: PaymentsCellProp<'status'>) => {
  return <Typography variant="body1">{cell.value}</Typography>;
};

const ActionCell = (cell: PaymentsCellProp<'actions'>) => {
  const actions = cell.getRowActions(cell.value.paymentId);
  return <ContextMenuButton>{actions}</ContextMenuButton>;
};

const BoxInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  whiteSpace: 'nowrap',
  alignItems: 'flexStart',
}));

const BoxTime = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'end',
  gap: theme.spacing(0.5),
}));
